import React from "react";

export default function SectionLoader({ leftSectioned = true, bgColor = "bg-white", buttonEnabled = true }) {
  const containerStyle = `w-full flex flex-col items-center justify-center ${bgColor} py-10 ${
    leftSectioned ? "md:flex-row" : "md:flex-row-reverse"
  }`;

  const imageContainerStyle = `w-full md:w-3/5 md:h-[38rem]`;

  return (
    <div className={`${containerStyle} animate-pulse`}>
      <div className={imageContainerStyle}>
        <div className="h-full w-full bg-gray-200 rounded-lg"></div>
      </div>

      <div className="w-full md:w-2/5 h-full text-left px-[1rem] pt-[1.5rem] md:mx-[3rem]">
        <div className="h-10 w-3/4 bg-gray-200 rounded mb-[1rem] md:mb-[2rem]"></div>
        <div className="space-y-3 mb-[2rem]">
          <div className="h-4 w-full bg-gray-200 rounded"></div>
          <div className="h-4 w-50 bg-gray-200 rounded"></div>
          <div className="h-4 w-50 bg-gray-200 rounded"></div>
        </div>
        {buttonEnabled && (
          <div className="h-10 w-32 bg-gray-300 rounded-full"></div>
        )}
      </div>
    </div>
  );
}
